import React from "react";
import { Popover, List, ListItem, ListItemText } from "@mui/material";

const MenuPopover = ({ anchorEl, open, onClose, menuItems }) => {
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
            <List sx={{ minWidth: "200px" }}>
                {menuItems.map((item, index) => (
                    <ListItem button key={index} onClick={item.onClick} sx={{cursor:"pointer"}}>
                        <ListItemText primary={item.label} />
                    </ListItem>
                ))}
            </List>
        </Popover>
    );
};

export default MenuPopover;
